import { otto } from "@gr-exports/head/nexus";

const { assignments } = otto.onex;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function isOnexGroup(onexId: string, groupId: string): boolean {
  const data = assignments.get();
  const group = data[onexId];
  return !!group && group === groupId;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function mapOnexGroup<OnexMap extends Record<string, unknown>, D = undefined>(
  onexId: string,
  groupMap: OnexMap,
  ...a: undefined extends D ? [] : [defaultValue: D]
): OnexMap[keyof OnexMap] | D {
  const data = assignments.get();
  const group = data[onexId];
  if (!group || groupMap[group] === undefined) return a[0] as D;
  return groupMap[group] as OnexMap[keyof OnexMap];
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function withOnex(onexId: string): {
  isGroup: (groupId: string) => boolean;
  mapGroup: <OnexMap extends Record<string, unknown>, D = undefined>(
    groupMap: OnexMap,
    ...a: undefined extends D ? [] : [defaultValue: D]
  ) => OnexMap[keyof OnexMap] | D;
} {
  return {
    isGroup: (groupId) => isOnexGroup(onexId, groupId),
    mapGroup: (groupMap, ...a) => mapOnexGroup(onexId, groupMap, ...a),
  };
}
